/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP8_ANSWERS = [
    'Tony hears a kitten outside of his room.',
    'Tony goes outside to his backyard to look for the kitten.',
    'Tony looks under a table, behind a bush, and inside a trashcan. He finds other animals, not the kitten.',
    'Eventually, Tony finds the kitten in a tree.',
    'Tony goes back into the house to find a bag for the kitten.',
    'Tony starts to climb up the tree but he can’t see the kitten.',
    'Suddenly, a squirrel jumps on Tony. But Tony manages to put the kitten in his bag.',
    'Tony gets scratches trying to climb down the tree. And he sets the bag down to let the kitten out.',
    'Suddenly, Tony and the kitten hear a noise. It’s another kitten!',
    'Bethany and Howard wake up because they can hear kittens. They go into their backyard.',
    'They are shocked to see lots of kittens drinking milk!',
    'Then, Tony brings other kittens to the backyard. He’s saved all the kittens from the tree.',
    'Bethany and Howard are surprised, but Tony doesn’t care. He and the kittens are having fun.',
];

// export const HHT1_EP8_ANSWER_SOUNDS = [
//     '/1_EP08_SB_TL_01.mp3',
//     '/1_EP08_SB_TL_02.mp3',
//     '/1_EP08_SB_TL_03.mp3',
//     '/1_EP08_SB_TL_04.mp3',
//     '/1_EP08_SB_TL_05.mp3',
//     '/1_EP08_SB_TL_06.mp3',
//     '/1_EP08_SB_TL_07.mp3',
//     '/1_EP08_SB_TL_08.mp3',
//     '/1_EP08_SB_TL_09.mp3',
//     '/1_EP08_SB_TL_10 re.mp3',
//     '/1_EP08_SB_TL_11.mp3',
//     '/1_EP08_SB_TL_12.mp3',
//     '/1_EP08_SB_TL_13.mp3',
// ];

export const HHT1_EP8_ANSWER_SOUNDS = [
    '/d8e01a301e2be99df98aadbdce6736e8.mp3',
    '/6bb5d17c2ff6544809b9d236ca9baf88.mp3',
    '/93f4340b79339901aa84e1763f5127b9.mp3',
    '/65d3a1a5b8722f10e7e93e4e35d5235b.mp3',
    '/69609384334b03baaa154b279ad418fc.mp3',
    '/3789f4ad7d2f6027714a877a47a45a09.mp3',
    '/ffdda00b5a43cc814b885595fbab904b.mp3',
    '/daf015f2b9acd94c30100584ef8c6307.mp3',
    '/a14e4a6398d745022ae628f3b0aeefe6.mp3',
    '/1580f845838d71768fa87316cfb6e545.mp3',
    '/b258612e94b63854f16b63282385033c.mp3',
    '/76f1a46b760cec7db12d19dda07366d7.mp3',
    '/9e43c0e761b5b81c5a636a591e372255.mp3',

];

export const HHT1_EP8_QUIZ_ITEMS = [{
    'A': HHT1_EP8_ANSWERS[4],
    'B': HHT1_EP8_ANSWERS[1],
    'SoundIndexA': 4,
    'SoundIndexB': 1,
    'answer': HHT1_EP8_ANSWERS[1],
    'sound': [2],
    'exception': false,
},
    {
        'A': HHT1_EP8_ANSWERS[3],
        'B': HHT1_EP8_ANSWERS[12],
        'SoundIndexA': 3,
        'SoundIndexB': 12,
        'answer': HHT1_EP8_ANSWERS[3],
        'sound': [4],
        'exception': false,
    },
    {
        'A': HHT1_EP8_ANSWERS[5],
        'B': HHT1_EP8_ANSWERS[10],
        'SoundIndexA': 5,
        'SoundIndexB': 10,
        'answer': HHT1_EP8_ANSWERS[5],
        'sound': [6, 7],
        'exception': false,
    },
    {
        'A': HHT1_EP8_ANSWERS[8],
        'B': HHT1_EP8_ANSWERS[6],
        'SoundIndexA': 8,
        'SoundIndexB': 6,
        'answer': HHT1_EP8_ANSWERS[8],
        'sound': [9, 10],
        'exception': true,
    },
    {
        'A': HHT1_EP8_ANSWERS[0],
        'B': HHT1_EP8_ANSWERS[11],
        'SoundIndexA': 0,
        'SoundIndexB': 11,
        'answer': HHT1_EP8_ANSWERS[11],
        'sound': [12],
        'exception': false,
    },

]
